<div class="card card-flush h-xl-100">
  <div class="card-body pt-5">

    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>Customer List</nz-page-header-title>
      <nz-page-header-subtitle>Manage your customer here</nz-page-header-subtitle>
      <nz-page-header-extra>

        @if (this.permission.Add) {
          <button nz-button nzType="primary" (click)="showModal()">Add New</button>
        }
      </nz-page-header-extra>

    </nz-page-header>
    <nz-divider></nz-divider>
    <div style="padding: 8px;float:right">
      <input type="text" style="width: 250px;margin-right: 8px;" nz-input
        placeholder="Search name / email / phone" [(ngModel)]="searchValue" (keydown)="onKeydown($event)" />

      <button nz-button nzSize="small" nzType="primary" (click)="search()"
      style="margin-right: 8px;">Search</button>
      <button nz-button nzSize="small" (click)="reset()">Reset</button>
      <button nz-button nzSize="small" (click)="export()"><i nz-icon nzType="export" nzTheme="outline"></i>
    Export</button>
  </div>
  <nz-table nzSize="small" style="width: 100%;" [nzScroll]="{ x: '1200px',y:'515px' }" #basicTable
    [nzData]="this.CustomerList" [nzLoading]="isTableLoading" nzBordered>
    <thead>
      <tr>
        <th nzWidth="250px" nzLeft>Customer Name</th>
        <th nzWidth="150px">Contact No.</th>
        <th nzWidth="350px">Email</th>
        <th nzWidth="400px">Address</th>
        <th nzWidth="350px">GST/TAX</th>
        <th nzWidth="150px">State</th>
        <th nzWidth="150px">Country</th>
        <th nzWidth="140px">Proforma Invoice</th>
        <th nzWidth="150px">Added Date</th>
        <th nzWidth="150px">Added By</th>
        <th nzWidth="160px" style="text-align:center" nzRight>Action</th>
      </tr>
    </thead>
    <tbody>
      @for (data of basicTable.data; track data) {
        <tr>
          <td nzLeft>{{ data.CustomerName }}</td>
          <td>
            <div class="contact-cell">
              <span>{{ data.CustomerContactNumber }}</span>
              @if (getNotificationStatus(data).hasWhatsApp) {
                <span nz-tooltip
                  nzTooltipTitle="WhatsApp notifications enabled" class="notification-icon whatsapp-icon">
                  <i nz-icon nzType="message" nzTheme="fill"></i>
                </span>
              }
            </div>
          </td>
          <td>
            <div class="email-cell">
              <span>{{ data.Email }}</span>
              @if (getNotificationStatus(data).hasEmail) {
                <span nz-tooltip
                  nzTooltipTitle="Email notifications enabled" class="notification-icon email-icon">
                  <i nz-icon nzType="mail" nzTheme="fill"></i>
                </span>
              }
            </div>
          </td>
          <td>{{ data.Address }}</td>
          <td>{{ data.Gstnumber }}</td>
          <td>{{ data.State }}</td>
          <td>{{ data.Country }}</td>
          <td>
            @if (data.ProformaRequirement === 'Required') {
              <nz-tag nzColor="red">Required</nz-tag>
            } @else if (data.ProformaRequirement === 'Optional') {
              <nz-tag nzColor="green">Optional</nz-tag>
            } @else {
              <nz-tag>Default</nz-tag>
            }
          </td>
          <td>{{ data.AddedDate | DatetimeConverter }}</td>
          <td>{{ data.AddedBy }}</td>
          <td nzRight style="text-align:center">
            <button class="btn btn-sm btn-light-primary" (click)="OpenEditPop(data)">Edit</button> &nbsp;
            <button class="btn btn-sm btn-light-danger" [disabled]="!this.permission.Delete"
            (click)="handleDelete(data)">Delete</button>
          </td>
        </tr>
      }
    </tbody>
  </nz-table>


  <nz-modal [nzWidth]="800" [nzStyle]="{ top: '20px' }" [(nzVisible)]="isVisible" [nzTitle]="modalTitle"
    [nzContent]="modalContent" [nzFooter]=null (nzOnCancel)="handleCancel()">
    <ng-template #modalTitle>{{PopUpTitle}}</ng-template>

    <ng-template #modalContent>
      <form nz-form [formGroup]="validateForm" (ngSubmit)="handleOk()">
        <nz-form-item>

          <nz-form-label [nzSpan]="8" nzRequired>Customer Name</nz-form-label>
          <nz-form-control [nzSpan]="14" [nzErrorTip]="NameError">
            <input nz-input formControlName="CustomerName" name="CustomerName" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="8">Contact Number</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <nz-input-group nzCompact>
              <nz-select class="country-select" [ngModel]="selectedCountry"
                (ngModelChange)="onCountryChange($event)" [ngModelOptions]="{standalone: true}"
                nzShowSearch nzPlaceHolder="Country">
                @for (country of countries; track country) {
                  <nz-option [nzValue]="country"
                    [nzLabel]="country.flag + ' ' + country.dialCode">
                  </nz-option>
                }
              </nz-select>
              <input nz-input formControlName="CustomerContactNumber"
                placeholder="Enter mobile number (optional)" type="tel" class="mobile-input"
                (blur)="onMobileNumberBlur()"
                (input)="onMobileNumberChange($any($event.target).value)">
            </nz-input-group>

            <!-- Validation Error Message -->
            @if (showMobileError && mobileValidationError) {
              <div class="error-message">
                <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
                {{ mobileValidationError }}
              </div>
            }

            <!-- Help Text -->
            @if (!showMobileError) {
              <div class="help-text">
                <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                Example: {{ selectedCountry.example }}
              </div>
            }
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="8">Email</nz-form-label>
          <nz-form-control pattern="emailPattern" [nzSpan]="14" nzErrorTip="Invalid Email">
            <input nz-input formControlName="Email" name="Email" />
          </nz-form-control>
        </nz-form-item>


        <nz-form-item>
          <nz-form-label [nzSpan]="8" nzRequired>Address</nz-form-label>
          <nz-form-control [nzSpan]="14" nzErrorTip="Address required">
            <textarea nz-input formControlName="Address" name="Address required"></textarea>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="8" nzRequired>State</nz-form-label>
          <nz-form-control [nzSpan]="14" nzErrorTip="State required">
            <input nz-input formControlName="State" name="State" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="8" nzRequired>Country</nz-form-label>
          <nz-form-control [nzSpan]="14" nzErrorTip="Country required">
            <nz-select formControlName="Country" nzShowSearch nzPlaceHolder="Select Country"
              class="full-width" (ngModelChange)="onMainCountryChange($event)">
              @for (country of countries; track country) {
                <nz-option [nzValue]="country.countryName"
                  [nzLabel]="country.countryName">
                  <span class="country-option">
                    <span class="country-flag">{{ country.flag }}</span>
                    <span class="country-name">{{ country.countryName }}</span>
                  </span>
                </nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="8">Proforma Invoice on Sale Order
            <i nz-icon nzType="info-circle" nz-tooltip
              nzTooltipTitle="Required: every Sale Order for this customer must quote an approved Proforma Invoice. Optional: never required for this customer. Default: product family / tenant-wide setting decides."></i>
          </nz-form-label>
          <nz-form-control [nzSpan]="14">
            <nz-select formControlName="ProformaRequirement" nzPlaceHolder="Default" nzAllowClear
              class="full-width">
              <nz-option nzValue="Required" nzLabel="Required"></nz-option>
              <nz-option nzValue="Optional" nzLabel="Optional"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="8" nzRequired>GST/TAX</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <input nz-input formControlName="Gst" name="Gst" />
          </nz-form-control>
        </nz-form-item>

        <!-- Notification Preferences Section -->
        <nz-divider nzText="Notification Preferences" nzOrientation="left"></nz-divider>

        <nz-form-item>
          <nz-form-label [nzSpan]="8">Email Notifications</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <nz-switch [(ngModel)]="NewCustomer.IsEmailNotification"
              [ngModelOptions]="{standalone: true}" nzCheckedChildren="Enabled"
              nzUnCheckedChildren="Disabled">
            </nz-switch>
            <div class="form-help-text">Enable email notifications for this customer</div>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="8">WhatsApp Notifications</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <nz-switch [(ngModel)]="NewCustomer.IsWhatsappNotification"
              [ngModelOptions]="{standalone: true}" nzCheckedChildren="Enabled"
              nzUnCheckedChildren="Disabled" (ngModelChange)="onWhatsAppNotificationChange($event)">
            </nz-switch>
            <div class="form-help-text">Enable WhatsApp notifications for this customer</div>
          </nz-form-control>
        </nz-form-item>

        <!-- Notification Types Selection (shown when WhatsApp is enabled) -->
        @if (NewCustomer.IsWhatsappNotification) {
          <nz-form-item>
            <nz-form-label [nzSpan]="8">Notification Types</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <nz-select [(ngModel)]="selectedNotificationTypeIds" [ngModelOptions]="{standalone: true}"
                nzMode="multiple" nzPlaceHolder="Select notification types" nzShowSearch
                [nzLoading]="isLoadingNotificationTypes"
                (ngModelChange)="onNotificationTypeSelectionChange($event)" style="width: 100%;">
                @for (type of availableNotificationTypes; track type) {
                  <nz-option
                    [nzValue]="type.ConfigurationId" [nzLabel]="type.DisplayName">
                  </nz-option>
                }
              </nz-select>
              <div class="form-help-text">
                <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                Select the types of notifications this customer should receive via WhatsApp
              </div>
            </nz-form-control>
          </nz-form-item>
        }

        <!-- Scheduling Configuration (shown when notification types with scheduling are selected) -->
        @if (NewCustomer.IsWhatsappNotification && NewCustomer.NotificationSubscriptions.length > 0) {
          <div>
            @for (subscription of NewCustomer.NotificationSubscriptions; track subscription; let i = $index) {
              <nz-form-item>
                <nz-form-label [nzSpan]="8">{{ subscription.NotificationTypeName }} Schedule</nz-form-label>
                <nz-form-control [nzSpan]="14">
                  <!-- Default Schedule Display -->
                  @if (subscription.UseDefaultSchedule) {
                    <div class="schedule-info">
                      <div class="default-schedule">
                        <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
                        <span>{{ subscription.ScheduleDescription }}</span>
                      </div>
                      @if (subscription.IsScheduleRequired) {
                        <div class="schedule-toggle">
                          <nz-switch [ngModel]="!subscription.UseDefaultSchedule"
                            (ngModelChange)="onCustomScheduleToggle(subscription.ConfigurationId, $event)"
                            nzSize="small" [ngModelOptions]="{standalone: true}">
                          </nz-switch>
                          <span class="toggle-label">Customize Schedule</span>
                        </div>
                      }
                    </div>
                  }
                  <!-- Custom Schedule Input -->
                  @if (!subscription.UseDefaultSchedule && subscription.IsScheduleRequired) {
                    <div
                      class="custom-schedule">
                      <nz-input-group nzCompact>
                        <input nz-input [(ngModel)]="subscription.CronScheduleExpression"
                          [ngModelOptions]="{standalone: true}"
                          placeholder="Enter cron expression (e.g., 0 10 * * *)"
                          (ngModelChange)="onCronExpressionChange(subscription.ConfigurationId, $event)"
                          style="width: 70%;">
                        <button nz-button nzType="default"
                          (click)="onCustomScheduleToggle(subscription.ConfigurationId, false)"
                          style="width: 30%;">
                          Use Default
                        </button>
                      </nz-input-group>
                      <!-- Schedule Description -->
                      <div class="schedule-description"
                        [class.valid]="validateCronExpression(subscription.CronScheduleExpression)"
                        [class.invalid]="!validateCronExpression(subscription.CronScheduleExpression)">
                        <i nz-icon
                          [nzType]="validateCronExpression(subscription.CronScheduleExpression) ? 'check-circle' : 'exclamation-circle'"
                        nzTheme="fill"></i>
                        <span>{{ subscription.ScheduleDescription }}</span>
                      </div>
                      <!-- Cron Help Text -->
                      <div class="cron-help">
                        <small class="text-muted">
                          Examples: "0 10 * * *" (Daily at 10 AM), "0 9 * * 1" (Weekly on Monday at 9
                          AM)
                        </small>
                      </div>
                    </div>
                  }
                </nz-form-control>
              </nz-form-item>
            }
          </div>
        }

        <!-- <ng-template #modalFooter>

        <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>

      </ng-template> -->
      <div class="text-center">
        <button nz-button nzType="primary" [nzLoading]="isLoading">Save</button>
      </div>

    </form>
  </ng-template>
</nz-modal>

</div>
</div>